// Beschläge & Verbinder — Presets legen Standard-Bohrbilder als Sacklöcher an
// (soweit auf der Fläche darstellbar) und führen eine Beschlagliste in
// part.meta.hardware. Kantenbohrungen (z. B. Dübelschäfte) hängen an der
// Stoßrichtung und entstehen deshalb über den Verbindungs-Assistenten
// (joinery.js, Stirnbohrungen); die Presets zählen sie nur in der Liste.
// Engine-frei.
import { cutoutsOf, clampCutout } from "./cutouts"

export const HARDWARE_PRESETS = {
  topfband: {
    label: "Topfband 35 mm (×2)",
    item: "Topfband 35 mm",
    count: 2,
    // Töpfe Ø35 T13 an der vorderen Kante (Bandseite), 100 mm von den Enden
    bores: (part) => {
      const z = -(part.width_mm / 2) + 22.5
      const inset = Math.min(100, Math.max(30, part.length_mm / 2 - 30))
      const x = part.length_mm / 2 - inset
      return [
        { shape: "circle", diameter_mm: 35, depth_mm: 13, side: "top", x_mm: -x, z_mm: z },
        { shape: "circle", diameter_mm: 35, depth_mm: 13, side: "top", x_mm: x, z_mm: z }
      ]
    }
  },
  exzenter: {
    label: "Exzenter 15 mm (×4)",
    item: "Exzenter 15 mm",
    count: 4,
    // Töpfe Ø15 T12, 50 mm von links/rechts und 34 mm von vorn/hinten
    bores: (part) => {
      const x = part.length_mm / 2 - 50
      const z = part.width_mm / 2 - 34
      return [
        { shape: "circle", diameter_mm: 15, depth_mm: 12, side: "top", x_mm: -x, z_mm: -z },
        { shape: "circle", diameter_mm: 15, depth_mm: 12, side: "top", x_mm: x, z_mm: -z },
        { shape: "circle", diameter_mm: 15, depth_mm: 12, side: "top", x_mm: -x, z_mm: z },
        { shape: "circle", diameter_mm: 15, depth_mm: 12, side: "top", x_mm: x, z_mm: z }
      ]
    }
  },
  duebel: {
    label: "Dübel 8×30 (×4, nur Liste)",
    item: "Dübel 8×30",
    count: 4,
    bores: () => [] // Kantenbohrungen nicht darstellbar
  }
}

export function hardwareOf(part) {
  return part.meta?.hardware ?? []
}

export function withHardware(part, presetKey, source = `${presetKey}-${Date.now().toString(36)}`) {
  const preset = HARDWARE_PRESETS[presetKey]
  if (!preset) return part.meta
  const bores = preset.bores(part).map((bore) => clampCutout({ ...bore, source }, part))
  const meta = {
    ...part.meta,
    hardware: [...hardwareOf(part), { type: presetKey, item: preset.item, count: preset.count, source }]
  }
  if (bores.length > 0) meta.cutouts = [...cutoutsOf(part), ...bores]
  return meta
}

export function withoutHardware(part, index) {
  const entries = hardwareOf(part)
  const entry = entries[index]
  const meta = { ...part.meta }
  const remaining = entries.filter((_, i) => i !== index)
  if (remaining.length > 0) meta.hardware = remaining
  else delete meta.hardware
  if (entry?.source) {
    const cutouts = cutoutsOf(part).filter((cutout) => cutout.source !== entry.source)
    if (cutouts.length > 0) meta.cutouts = cutouts
    else delete meta.cutouts
  }
  return meta
}
